import { ResultLayout } from '@/layout/resultLayout/ResultLayout';

export default ResultLayout;
